import { Subject } from 'rxjs';
import * as _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CommonDataService {
    constructor(http) {
        this.http = http;
        this.dataSource = new Subject();
        this.dataSourceSub = new Subject();
        this.loaderStatus = new Subject();
        this.setBreadCrumbs = (data, breadCrmb = null) => {
            if (data) {
                const paths = [];
                paths.push({ breadCrumb: 'Home', url: 'home' });
                paths.push(data);
                if (breadCrmb) {
                    paths.push(breadCrmb);
                }
                this.dataSource.next(paths);
            }
            else {
                this.dataSource.next('');
            }
        };
        this.setSubBreadCrumb = (val) => {
            this.dataSourceSub.next(val);
        };
        this.setLoader = (val) => {
            this.loaderStatus.next(val);
        };
        this.convertToString = (obj) => {
            return _.cloneDeepWith(obj, value => {
                return !_.isPlainObject(value) ? _.toString(value) : undefined;
            });
        };
        this.customDate = (value) => {
            const month = new Array();
            const parseDate = new Date(value);
            let suffix = 'th';
            const day = parseDate.getDate().toString();
            month[0] = 'January';
            month[1] = 'February';
            month[2] = 'March';
            month[3] = 'April';
            month[4] = 'May';
            month[5] = 'June';
            month[6] = 'July';
            month[7] = 'August';
            month[8] = 'September';
            month[9] = 'October';
            month[10] = 'November';
            month[11] = 'December';
            if (day === '1' || day === '21' || day === '31') {
                suffix = 'st';
            }
            else if (day === '2' || day === '22') {
                suffix = 'nd';
            }
            else if (day === '3' || day === '23') {
                suffix = 'rd';
            }
            return day + suffix + ' ' + month[parseDate.getMonth()] + ' ' + parseDate.getFullYear();
        };
    }
}
CommonDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CommonDataService_Factory() { return new CommonDataService(i0.ɵɵinject(i1.HttpClient)); }, token: CommonDataService, providedIn: "root" });
